import React, { useState } from "react";
import "./LeftNavBar.css";
import logoImg from "../../../assets/logos/white-logo.svg";
import shrinklogoImg from "../../../assets/logos/shirnk-logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { routePath as RP } from "../../routes/routepath";
import dashboardSvg from "../../../assets/icons/dashboard.svg"
import userSvg from "../../../assets/icons/users.svg"
import articleSvg from "../../../assets/icons/article.svg"
import blogSvg from "../../../assets/icons/blog.svg"
import newsletterSvg from "../../../assets/icons/newsletter.svg"
import registeredEmailSvg from "../../../assets/icons/register-email.svg"
import uploadSvg from "../../../assets/icons/uploadpdf.svg"
import documentSvg from "../../../assets/icons/document.png"
import chatSvg from "../../../assets/icons/chat.svg"
import aqsvg from "../../../assets/icons/showqa.svg"
import deleteSvg from "../../../assets/icons/delete.svg"

function LeftNavBar({
  isOpen,
  isMobileOpen,
  onMobileNavHide,
  setIsMobileNavOpen,
}) {
  const navigate = useNavigate();
  const [openArticleDropdown, setOpenArticleDropdown] = useState(false);
  const [openChatDropdown, setOpenChatDropdown] = useState(false);
  const [openBlogDropdown, setOpenBlogDropdown] = useState(false);

  const location = useLocation();
  const path = location.pathname;

  const closeDropdowns = () => {
    setOpenArticleDropdown(false);
    setOpenChatDropdown(false);
    setOpenBlogDropdown(false);
  };

  const openArticleToggle = () => {
    setOpenArticleDropdown((isOpen) => !isOpen);
    setOpenChatDropdown(false);
    setOpenBlogDropdown(false);
  };

  const openChatToggle = () => {
    setOpenChatDropdown((isOpen) => !isOpen);
    setOpenArticleDropdown(false);
    setOpenBlogDropdown(false);
  };

  const openBlogToggle = () => {
    setOpenBlogDropdown(!openBlogDropdown);
    setOpenArticleDropdown(false);
    setOpenChatDropdown(false);
  };

  const navigatedashboard = () => {
    navigate("/dashboard");
    setIsMobileNavOpen(false);
    closeDropdowns();
  };

  const navigateUsers = () => {
    navigate("/users");
    setIsMobileNavOpen(false);
    closeDropdowns();
  };

  const navigateUserBlog = () => {
    navigate("/userBlog");
    setIsMobileNavOpen(false);
  };

  const navigateAdminBlogs = () => {
    navigate("/adminBlogs");
    setIsMobileNavOpen(false);
  };

  const showAdminArticle = () => {
    navigate("/adminArticle");
    setIsMobileNavOpen(false);
  };

  const navigateUserArticle = () => {
    navigate("/userArticle");
    setIsMobileNavOpen(false);
  };

  const navigateTechnologies = () =>{
     navigate("/technologies");
    closeDropdowns();
    setIsMobileNavOpen(false);
  }
  const navigateAdminNewsletter = () => {
    navigate("/adminNewsletter");
    closeDropdowns();
    setIsMobileNavOpen(false);
  };

  const navigateRegisteredEmail = () => {
    navigate("/newsletterRegisteredEmail");
    closeDropdowns();
    setIsMobileNavOpen(false);
  }

  const navigatechatdashboard = () => {
    navigate("/chatBotDashboard");
    setIsMobileNavOpen(false);
    closeDropdowns();
    setOpenBlogDropdown(false);
  };

  const navigatenewchatdashboard = () => {
    navigate("/showChatBotDashboard");
    setIsMobileNavOpen(false);
    closeDropdowns();
  };

  const showpdfUpload = () => {
    navigate("/uploadPdf");
    setIsMobileNavOpen(false);
    closeDropdowns();
    setOpenBlogDropdown(false);
  };

  const showDocuments = () => {
    navigate("/documents");
    setIsMobileNavOpen(false);
    // setOpenDropdown(false);
    setOpenBlogDropdown(false);
  };

  const showDeletedDocuments = () => {
    navigate("/deletedDocuments");
    setIsMobileNavOpen(false);
    setOpenBlogDropdown(false);
  };

  // const showUserAgentChats = () => {
  //   navigate("/userAgentChats");
  //   setIsMobileNavOpen(false);
  // };

  // const showUserBotChats = () => {
  //   navigate("/userBotChats");
  //   setIsMobileNavOpen(false);
  // };

  const showNewUserAgentChats = () => {
    navigate("/showUserAgentChats");
    setIsMobileNavOpen(false);
  };

  const showNewUserBotChats = () => {
    navigate("/showUserBotChats");
    setIsMobileNavOpen(false);
  };

  const showClientDetectionEmails = () => {
    navigate(RP.showClientDetectionEmails);
    closeDropdowns();
    setIsMobileNavOpen(false);
  }

  const showFeatures = ()=>{
    navigate(RP.showFeatures);
    closeDropdowns();
    setIsMobileNavOpen(false);
  }

  const showDeletedQA = () => {
    navigate("/showDeletedQdrantQa");
    setIsMobileNavOpen(false);
    
  };
  // const navigateUserArticle = () => {
  //   navigate("/userArticle");
  // };

   const showSavedQA = () => {
    navigate("/showSavedQdrantQa");
    closeDropdowns();
    setIsMobileNavOpen(false);
  };




    return (
      <>
        <div
          className={`leftnavrbar ${isOpen ? "shrinkMenu" : ""} ${isMobileOpen ? "left-0" : ""
            }`}
        >
          <div className="logo_cross_icon_wraper">
            <div className="leftnavbar_logo">
              <img src={logoImg} className="full_logo" alt="TechFeatures" onClick={() => {
                navigate("/dashboard");
              }} />
              <img
                src={shrinklogoImg}
                className="shrink_logo"
                alt="TechFeatures"
                onClick={() => {
                  navigate("/dashboard");
                }}
              />
            </div>
            <div className="leftNavbar_cross_icon" onClick={onMobileNavHide}>
            <i className="bi bi-x-lg"></i>
          </div>
          </div>

          <div className="leftnavbar_menu_box">
            <div className="menu-links">
              <h3>Blog</h3>
              <ul>
                {/* DASHBOARD */}
                <li
                  className={path === "/dashboard" ? "active" : ""}
                  onClick={navigatedashboard}
                >
                  <img src={dashboardSvg} alt="Dashboard" />
                  <span>Dashboard</span>
                </li>

                {/* USERS */}
                <li
                  className={path === "/users" ? "active" : ""}
                  onClick={navigateUsers}
                >
                  <img src={userSvg} alt="User" />
                  <span>Users</span>
                </li>

                {/* ARTICLE DROPDOWN */}
                <div className="dropdown_menu_wraper">
                  <li
                    className="dropdown_menu"
                    onClick={openArticleToggle}
                  >
                    <div className="leftnavbar_dropdown_text">
                      <img src={articleSvg} alt="Article" />
                      <span>Article</span>
                    </div>

                    <div
                      className={`leftnavbar_dropdown_icon ${openArticleDropdown ? "rotateDropdownIcon" : ""
                        }`}
                    >
                      <i class="bi bi-chevron-right dropdown_arrow"></i>
                    </div>
                  </li>

                  {openArticleDropdown && (
                    <ul className="sub_dropdown_menu">
                      <li
                        className={path === "/adminArticle" ? "active" : ""}
                        onClick={showAdminArticle}
                      >
                        Admin Article
                      </li>

                      <li
                        className={path === "/userArticle" ? "active" : ""}
                        onClick={navigateUserArticle}
                      >
                        User Article
                      </li>
                    </ul>
                  )}
                </div>

                {/* BLOG DROPDOWN */}
                <div className="dropdown_menu_wraper">
                  <li
                    className="dropdown_menu"
                    onClick={openBlogToggle}
                  >
                    <div className="leftnavbar_dropdown_text">
                      <img src={blogSvg} alt="blog" />
                      <span>Blog</span>
                    </div>

                    <div
                      className={`leftnavbar_dropdown_icon ${openBlogDropdown ? "rotateDropdownIcon" : ""
                        }`}
                    >
                      <i class="bi bi-chevron-right dropdown_arrow"></i>
                    </div>
                  </li>

                  {openBlogDropdown && (
                    <ul className="sub_dropdown_menu">
                      <li
                        className={path === "/adminBlogs" ? "active" : ""}
                        onClick={navigateAdminBlogs}
                      >
                        Admin Blog
                      </li>

                      <li
                        className={path === "/userBlog" ? "active" : ""}
                        onClick={navigateUserBlog}
                      >
                        User Blog
                      </li>
                    </ul>
                  )}
                </div>

                 {/* Technology  */}

                <li
                  className={path === "/technologies" ? "active" : ""}
                  onClick={navigateTechnologies}
                >
                  <img src={registeredEmailSvg} alt="RegisterdEmail" />
                  <span>Technologies</span>
                </li> 

                {/* NEWSLETTER */}
                <li
                  className={path === "/adminNewsletter" ? "active" : ""}
                  onClick={navigateAdminNewsletter}
                >
                  <img src={newsletterSvg} alt="Newsletter" />
                  <span>Newsletter</span>
                </li>

                {/* REGISTERED EMAIL */}
                <li
                  className={path === "/newsletterRegisteredEmail" ? "active" : ""}
                  onClick={navigateRegisteredEmail}
                >
                  <img src={registeredEmailSvg} alt="RegisterdEmail" />
                  <span>Registered Email</span>
                </li>
              </ul>
            </div>
            <div>
              <h3>ChatBot</h3>
              <ul>
                {/* <li className={path === "/chatBotDashboard" ? "active" : ""}
                  onClick={navigatechatdashboard}>
                  <img src={dashboardSvg} alt="Dashboard" />
                  <span>Dashboard</span>
                </li> */}
                <li className={path === "/showChatBotDashboard" ? "active" : ""}
                  onClick={navigatenewchatdashboard}>
                  <img src={dashboardSvg} alt="Dashboard" />
                  <span>Dashboard</span>
                </li>
                {/* <li className={path === "/uploadPdf" ? "active" : ""}
                  onClick={showpdfUpload}>
                  <img src={uploadSvg} alt="uploadPdf" />
                  <span>Upload PDF</span>
                </li> */}

                <li
                  className={path === "/uploadPdf" ? "active" : ""}
                  onClick={showpdfUpload}
                >
                  <img src={uploadSvg} alt="uploadPdf" />
                  <span>Upload PDF</span>
                </li>

                <li className={path === "/documents" ? "active" : ""}
                      onClick={showDocuments}>
                      <img src={documentSvg} alt="Documents" />
                      <span>Documents</span>
                </li>
                <li className={path === RP.deletedDocuments ? "active" : ""}
                      onClick={showDeletedDocuments}>
                      <img src={deleteSvg} alt="Deleted Documents" />
                      <span>Deleted Documents</span>
                </li>
                <div className="dropdown_menu_wraper">
                  <li
                    className="dropdown_menu"
                    onClick={openChatToggle}
                  >
                    <div className="leftnavbar_dropdown_text">
                      <img src={chatSvg} alt="Chat" />
                      <span>Chats</span>
                    </div>

                    <div
                      className={`leftnavbar_dropdown_icon ${openChatDropdown ? "rotateDropdownIcon" : ""
                        }`}
                    >
                      <i class="bi bi-chevron-right dropdown_arrow"></i>
                    </div>
                  </li>

                  {openChatDropdown && (
                    <ul className="sub_dropdown_menu">
                      <li
                        className={path === "/userAgentChats" ? "active" : ""}
                        onClick={showNewUserAgentChats}
                      >
                        User-Agent Chats
                      </li>

                      <li
                        className={path === "/userBotChats" ? "active" : ""}
                        onClick={showNewUserBotChats}
                      >
                        User-Bot Chats
                      </li>
                    </ul>
                  )}
                </div>

                  {/* {openChatDropdown && (
                    <ul className="sub_dropdown_menu">
                      <li
                        className={path === "/userAgentChats" ? "active" : ""}
                        onClick={showUserAgentChats}
                      >
                        User/Agent Chats
                      </li>

                      <li
                        className={path === "/userBotChats" ? "active" : ""}
                        onClick={showUserBotChats}
                      >
                        User/Bot Chats
                      </li>
                    </ul>
                  )}
                </div> */}
                {/* <li className={path === "/showSavedQdrantQa" ? "active" : ""}
                  onClick={showSavedQA}>
                  <img src={aqsvg} alt="Q/A" />
                  <span>Show Saved Q/A</span>
                </li>
                <li className={path === "/showDeletedQdrantQa" ? "active" : ""}
                  onClick={showDeletedQA}>
                  <img src={deleteSvg} alt="Q/A" />
                  <span>Show Deleted Q/A</span>
                </li> */}
                <li className={path === RP.showClientDetectionEmails ? "active" : ""}
                  onClick={showClientDetectionEmails}>
                  <img src={registeredEmailSvg} alt="detected clients" />
                  <span>Show client detection emails</span>
                </li>
                <li className={path === RP.showFeatures ? "active" : ""}
                  onClick={showFeatures}>
                  <img src={registeredEmailSvg} alt="detected clients" />
                  <span>Features</span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </>
    );
  }

  export default LeftNavBar;
